// extracted by mini-css-extract-plugin
module.exports = {"icon":"Banner-module__icon___DF14S","icon--no-title":"Banner-module__icon--no-title___4rovw","text":"Banner-module__text___IjoNi","title":"Banner-module__title___hlRmM"};